const openMeasureModal = () => {
    document.querySelector('.measure-table-modal').classList.remove('hide');
}

const closeMeasureModal = () => {
    document.querySelector('.measure-table-modal').classList.add('hide');
}

// Cart Drawer functionality
class CartDrawer {
    constructor() {
        this.drawer = document.querySelector('[data-cart-drawer]');
        this.overlay = document.querySelector('[data-cart-drawer-overlay]');
        this.closeButton = document.querySelector('[data-cart-drawer-close]');
        this.body = document.querySelector('[data-cart-drawer-body]');
        this.subtotalElement = document.querySelector('[data-cart-subtotal]');
        this.cartIcon = document.querySelector('.header-tools-cart');

        this.bindEvents();
    }

    bindEvents() {
        // Close drawer events
        if (this.closeButton) {
            this.closeButton.addEventListener('click', () => this.close());
        }
        if (this.overlay) {
            this.overlay.addEventListener('click', () => this.close());
        }

        // Cart icon click event
        if (this.cartIcon) {
            this.cartIcon.addEventListener('click', (e) => {
                e.preventDefault();
                this.open();
            });
        }

        // Listen for add to cart button clicks
        document.addEventListener('click', (e) => {
            if (e.target.matches('.add-to-cart')) {
                e.preventDefault();
                const form = e.target.closest('form');
                if (form) {
                    this.addToCart(form);
                }
            }
        });

        // Delegate events for cart items
        if (this.body) {
            this.body.addEventListener('click', (e) => {
                const plus = e.target.closest('[data-quantity-plus]');
                const minus = e.target.closest('[data-quantity-minus]');
                const remove = e.target.closest('[data-item-remove]');

                if (plus) {
                    const input = plus.previousElementSibling;
                    const currentValue = parseInt(input.value);
                    this.updateQuantity(input.dataset.itemKey, currentValue + 1);
                } else if (minus) {
                    const input = minus.nextElementSibling;
                    const currentValue = parseInt(input.value);
                    if (currentValue > 1) {
                        this.updateQuantity(input.dataset.itemKey, currentValue - 1);
                    }
                } else if (remove) {

                    const item = remove.closest('[data-cart-item]');
                    const key = item.dataset.cartItemKey;
                    this.removeItem(key);
                }
            });
        }

    }

    open() {
        this.drawer.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        this.body.scrollTop = 0;
    }

    close() {
        this.drawer.classList.remove('is-active');
        document.body.style.overflow = '';
    }

    async addToCart(form) {
        this.body.classList.add('loading');
        try {
            const formData = new FormData(form);
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (response.ok) {
                await this.updateCartContent();
                this.open();
            } else if (response.status === 422) {
                alert('Seu carrinho já tem a quantidade máxima deste item.');
                const messageContainer = form.querySelector('.product-message');
                if (messageContainer) {
                    messageContainer.classList.add('error-message');
                    messageContainer.textContent = '';
                    messageContainer.textContent = 'Seu carrinho já tem a quantidade máxima deste item.';
                }
            } else {
                console.error('Erro ao adicionar ao carrinho:', response.status);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            this.body.classList.remove('loading');
        }
    }

    async updateQuantity(key, newQuantity) {
        if (newQuantity < 0) return;
        this.body.classList.add('loading');
        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: key,
                    quantity: newQuantity
                })
            });

            if (response.ok) {
                await this.updateCartContent();
            } else if (response.status === 422) {
                alert('Seu carrinho já tem a quantidade máxima deste item.');
                const form = e.target.closest('.product-form');
                const messageContainer = form.querySelector('.product-message');
                if (messageContainer) {
                    messageContainer.classList.add('error-message');
                    messageContainer.textContent = '';
                    messageContainer.textContent = 'Seu carrinho já tem a quantidade máxima deste item.';
                }
            } else {
                console.error('Erro ao adicionar ao carrinho:', response.status);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            this.body.classList.remove('loading');
        }
    }

    async removeItem(key) {
        this.body.classList.add('loading');
        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: key,
                    quantity: 0
                })
            });

            if (response.ok) {
                await this.updateCartContent();
            } else if (response.status === 422) {
                alert('Seu carrinho já tem a quantidade máxima deste item.');
                const form = e.target.closest('.product-form');
                const messageContainer = form.querySelector('.product-message');
                if (messageContainer) {
                    messageContainer.classList.add('error-message');
                    messageContainer.textContent = '';
                    messageContainer.textContent = 'Seu carrinho já tem a quantidade máxima deste item.';
                }
            } else {
                console.error('Erro ao adicionar ao carrinho:', response.status);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            this.body.classList.remove('loading');
        }
    }


    async updateCartContent() {
        try {
            // Primeiro, vamos buscar o estado atual do carrinho
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();
            // Se o carrinho estiver vazio, atualizamos o conteúdo diretamente
            if (cartData.item_count === 0) {
                this.body.innerHTML = `
                    <div class="cart-drawer__empty">
                        <p>Your cart is empty</p>
                        <button class="button button--secondary" data-cart-drawer-close>
                            Continue Shopping
                        </button>
                    </div>
                `;
                this.updateCartCount(0);
                return;
            }

            // Se houver itens, buscamos o HTML atualizado do carrinho
            const response = await fetch('/');
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newCartContent = doc.querySelector('[data-cart-drawer-body]');

            if (newCartContent && this.body) {
                this.body.innerHTML = newCartContent.innerHTML;
                // Re-inicializa eventos dos produtos relacionados
                if (typeof initRelatedProductsEvents === 'function') {
                    initRelatedProductsEvents();
                }
            }

            // Atualizamos o contador do carrinho
            this.updateCartCount(cartData.item_count);
        } catch (error) {
            console.error('Error:', error);
        }
    }

    updateCartCount(count) {
        // Update cart count in header if it exists
        const cartCountElements = document.querySelectorAll('.cart-item-count');
        cartCountElements.forEach(element => {
            element.textContent = count;
        });

        // Update cart dot indicator if it exists
        const cartLink = document.querySelector('.header-tools-cart');
        if (cartLink) {
            if (count > 0) {
                cartLink.classList.add('cart-has-content');
            } else {
                cartLink.classList.remove('cart-has-content');
            }
        }
    }
}

function initRelatedProductsEvents() {
  // Swiper (evita duplicidade)
  if (window.Swiper && document.querySelector('.related-swiper')) {
    new Swiper('.related-swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: false,
    });
  }

  // Quantidade
  document.querySelectorAll('.cart-related-products').forEach(function (container) {
    container.addEventListener('click', function (e) {
      if (e.target.classList.contains('qty-plus') || e.target.classList.contains('qty-minus')) {
        e.preventDefault();
        const input = e.target.closest('.qty-controls').querySelector('input[name="quantity"]');
        let value = parseInt(input.value, 10) || 1;
        if (e.target.classList.contains('qty-plus')) value++;
        if (e.target.classList.contains('qty-minus') && value > 1) value--;
        input.value = value;
      }
    });
  });

  // Adicionar ao carrinho via AJAX
  document.querySelectorAll('.related-product-form').forEach(function (form) {
    // Evita múltiplos listeners
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn = form.querySelector('.add-related-btn');
      const message = form.querySelector('.product-message');
      btn.classList.add('loading');
      message.textContent = '';
      const formData = new FormData(form);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (response.ok) {
          if (window.cartDrawerInstance && typeof window.cartDrawerInstance.updateCartContent === 'function') {
            await window.cartDrawerInstance.updateCartContent();
            window.cartDrawerInstance.open();
            // Re-inicializa eventos após atualizar o conteúdo
            initRelatedProductsEvents();
          } else {
            window.location.reload();
          }
        } else if (response.status === 422) {
          message.classList.add('error-message');
          message.textContent = 'Seu carrinho já tem a quantidade máxima deste item.';
        } else {
          message.classList.add('error-message');
          message.textContent = 'Erro ao adicionar ao carrinho.';
        }
      } catch (err) {
        message.classList.add('error-message');
        message.textContent = 'Erro inesperado.';
      } finally {
        btn.classList.remove('loading');
      }
    });

    // Troca de variante
    const variantSelector = form.querySelector('.variant-selector');
    if (variantSelector) {
      variantSelector.addEventListener('change', function () {
        // O select já tem o name="id", então o valor enviado será o correto
      });
    }
  });
}

// Initialize cart drawer when DOM is loaded
document.addEventListener('DOMContentLoaded', function () {
  window.cartDrawerInstance = new CartDrawer();
  initRelatedProductsEvents();
});
